import gql from 'graphql-tag';
// import { LeadFragment } from '../fragments';

export default gql`
  query GetSearchOptions($networkID: String) {
    getSearchOptions(networkID: $networkID) {
      vendors {
        vendorID
        vendorName
      }
      layers {
        vendorID
        layerID
        description
      }
      categories {
        layerID
        mpVendorCampaignID
        mpVendorCampaignName
        description
      }
    }
  }
`;
